import JSZip from "jszip";
import { DownloadBlobFile } from "../../Shared/Utils/fileHelpers";
import { buildCsvSections } from "./exportCsvSections";

export const exportReportToCsvZip = async ({ filename, model, t }) => {
  const sections = buildCsvSections({ model, t });

  if (!sections.length) {
    return 0;
  }

  const zip = new JSZip();
  sections.forEach((section) => {
    zip.file(`${section.filename}.csv`, `\uFEFF${section.content}`);
  });

  const blob = await zip.generateAsync({ type: "blob" });
  DownloadBlobFile(blob, filename);
  return sections.length;
};
